import React from 'react'

export default class IconsMainNavAllContacts extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <g clipPath='url(#clip0_44_4932)'>
                    <path
                        d='M12 13.3333C12 12.2724 11.5786 11.255 10.8284 10.5049C10.0783 9.75474 9.06087 9.33331 8 9.33331C6.93913 9.33331 5.92172 9.75474 5.17157 10.5049C4.42143 11.255 4 12.2724 4 13.3333'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8 9.33333C9.47276 9.33333 10.6667 8.13943 10.6667 6.66667C10.6667 5.19391 9.47276 4 8 4C6.52724 4 5.33334 5.19391 5.33334 6.66667C5.33334 8.13943 6.52724 9.33333 8 9.33333Z'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8 1.33331C4.3181 1.33331 1.33334 4.31808 1.33334 7.99998C1.33334 11.6819 4.3181 14.6666 8 14.6666Z'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_44_4932'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
